import Highcharts from 'highcharts';
import HighchartsMore from "highcharts/highcharts-more";
import sankey from 'highcharts/modules/sankey';
import dependency_wheel from 'highcharts/modules/dependency-wheel';
import heatmap from 'highcharts/modules/heatmap';
import solid_gauge from 'highcharts/modules/solid-gauge';

export default {
  install() {
    HighchartsMore(Highcharts);
    sankey(Highcharts);
    dependency_wheel(Highcharts);
    heatmap(Highcharts);
    solid_gauge(Highcharts);
  },
};
